import API from "@/config/api.js";
import PartnerService from "../services/partner.service"
// import {API_FORM} from "@/config/api.js";
// import moment from 'moment'


class RevenueStatisticService {
	searchRevenue(conditions) {
    const params = {
      start_date: conditions.start_date,
      contract_no: conditions.contract_no || "",
      invoice_no: conditions.invoice_no || ""
    };

    if (conditions.end_date) {
      params.end_date = conditions.end_date;
    }

    return API.get("statistic/revenue/", { params })
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  exportStatisticFile(conditions) {
    const params = {
      start_date: conditions.start_date,
      contract_no: conditions.contract_no || "",
      invoice_no: conditions.invoice_no || ""
    };

    if (conditions.end_date) {
      params.end_date = conditions.end_date;
    }

    return API.get("statistic/revenue/export/", { params })
    .then(
      (response) => {
        return response.data;
      },
      (error) => {
        return Promise.reject(error);
      }
    )
  }

  getListSupplier(page, size, type) {
    return PartnerService.getListData(page, size, type)
  }
}

export default new RevenueStatisticService();
